import { useState, useMemo, useEffect, useRef } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './components/ui/tabs';
import { MetricsOverview } from './components/MetricsOverview';
import { EngagementCharts } from './components/EngagementCharts';
import { GrowthCharts } from './components/GrowthCharts';
import { TopPerformers } from './components/TopPerformers';
import { Demographics } from './components/Demographics';
import { PostsTable } from './components/PostsTable';
import { HashtagCloud } from './components/HashtagCloud';
import { SentimentAnalysis } from './components/SentimentAnalysis';
import { InfluencerPieCharts } from './components/InfluencerPieCharts';
import { FacebookReactions } from './components/FacebookReactions';
import { PostTypeInsights } from './components/PostTypeInsights';
import { Calendar as CalendarIcon, Plus, FileDown, Loader2, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { PdfModeContext, PdfSeriesGrid } from './components/pdf/PdfModeContext';
import { PDF_VARIANTS, pinPdfLayout, type PdfVariant } from './components/pdf/pdfLayout';
import { Calendar } from './components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './components/ui/popover';
import { Button } from './components/ui/button';
import { cn } from './components/ui/utils';
import { Toaster } from './components/ui/sonner';
import { initialPostsData, calculateTotalSpent, type Post } from './components/shared/postsData';
import "./index.css";
import "./styles/globals.css";
import { format, set } from "date-fns";
import { Calendar as CalendarComponent } from "./components/ui/calendar";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Skeleton } from '@mui/material';
import { AnalyticsService } from '../../../../../core/services';
import * as gtUtil from "../../../../../core/utility";
import { RolesService } from '../../../../../core/services/roles.service';
import { Loading } from '../../../../../redux/action';
import { connect } from 'react-redux';
import { platform } from 'os';
import { NoData } from './components/ui/noData';
import RechartsNumberTooltip from './components/ui/rechartsNumberTooltip';
type PlatformType = "instagram" | "facebook" | "youtube";
interface Props {
  linkedCampaignId?: any;
  UserReducer: any;
  UserID: any;
  loading: (data: any) => void;
  selectCampaign: any;
  getSubscriptionDetail: any;
  share_access_key?: any;
  // Shown on the PDF report (brand page + shared link both pass it)
  campaignTitle?: string;
}

const methods = new gtUtil.Methods()
const analyticsService = new AnalyticsService();
const rolesService = new RolesService();
  const today = new Date();


const DetailedAnalyticsBrandPulseNew: React.FC<Props> = (props: Props) => {
  const [selectedPlatform, setSelectedPlatform] = useState('all');
  const [dateRange, setDateRange] = useState('Till Date');
  const [customStartDate, setCustomStartDate] = useState<Date | undefined>(new Date('2024-01-01'));
  const [customEndDate, setCustomEndDate] = useState<Date | undefined>(new Date('2024-11-11'));
  const [isAddPostDialogOpen, setIsAddPostDialogOpen] = useState(false);
  const [posts, setPosts] = useState<Post[]>(initialPostsData);


  const [dateTo, setDateTo] = useState<Date>(today);
  const [dateFrom, setDateFrom] = useState<Date>(
    new Date(today.getFullYear(), today.getMonth(), today.getDate() - 180)
  );
  // const totalSpent = useMemo(() => {
  //   return calculateTotalSpent(posts, selectedPlatform);
  // }, [posts, selectedPlatform]);
  const [dataMetrics, setDataMetrics] = useState<any>([]);
  const [loadingMetrics, setLoadingMetrics] = useState(false);
  // True until the very first metrics fetch resolves. Keeps the metrics cards in
  // a loading (skeleton) state on initial load instead of flashing "--" while the
  // (often slow) all-platform dashboard request is still in flight.
  const [initialMetricsLoading, setInitialMetricsLoading] = useState(true);
  // Latest-request-wins guard. selectedNumDays settles (7 -> actual range) on mount
  // and platform toggles fire overlapping metrics requests; we only apply the
  // response (and clear loading) for the most recent request so a slow/stale
  // response can't blank the cards with "--" after good data has loaded.
  const metricsReqId = useRef(0);
  const [loadingInfluencerType, setLoadingInfluencerType] = useState(false);
  const [loadingContentType, setLoadingContentType] = useState(false);
  const [influencerByType, setInfluencerByType] = useState<any>([]);
  const [fbViewData, setFbViedData] = useState<any>([]);
  const [sentimentData, setSentimentData] = useState<any>([]);
  const [selectedTab, setSelectedTab] = useState("posts");
  const [topPerformerData, setTopPerformerData] = useState<any>([]);
  const [hashTagData, setHashTagData] = useState<any>([]);
  const [influencerTypeData, setInfluencerTypeData] = useState<any>([]);
  const [loadingTopPerformer, setLoadingTopPerformer] = useState(false);
  const [demography, setDemography] = useState<any>(null);
  const [selectedNumDays, setSelectedNumDays] = useState<number | null>(7);
  const [isQuickRange, setIsQuickRange] = useState(false);
  // False until the campaign's own start date has been applied to the range (see the effect
  // below). Dashboard fetches wait on it so they don't first load the old 180-day default.
  const [rangeReady, setRangeReady] = useState(false);
  const [processingUrls, setProcessingUrls] = useState<any>([]);
  
  const calcNumDays = (fromDate:any) => {
  if (!fromDate) return null;

  const today = new Date();
  const diffTime = today.getTime() - fromDate.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

  return diffDays < 1 ? 1 : diffDays; 
};
const setLastDays = (days:any) => {
  setIsQuickRange(true);   // tell the system this is a quick button

  const today = new Date();

  const from = new Date();
  from.setDate(today.getDate() - days);

  setDateFrom(from);
  setDateTo(today);

  setSelectedNumDays(days); 
};
useEffect(() => {
  if (!dateFrom) return;

  // ❗ Skip recalculation if range is selected using buttons
  if (isQuickRange) {
    setIsQuickRange(false); // reset so next manual change works
    return;
  }

  const days = calcNumDays(dateFrom);
  setSelectedNumDays(days);

}, [dateFrom, console.log("dateFrom", selectedNumDays)]);

const handleFromDateSelect = (date: Date | undefined) => {
  if (!date) return;

  setIsQuickRange(false); // custom mode
  
  setDateFrom(date);

  // ❗ if fromDate > toDate → adjust toDate
  if (dateTo && date > dateTo) {
    setDateTo(date);
  }
};

const handleToDateSelect = (date: Date | undefined) => {
  if (!date) return;

  setIsQuickRange(false); // custom range

  // ❗ prevent selecting To Date < From Date
  if (dateFrom && date < dateFrom) {
    setDateTo(dateFrom);  // auto-fix
    return;
  }

  setDateTo(date);
};

// Open the dashboard on the campaign's real span instead of a fixed "last 180 days".
// Start = earliest of (first post, campaign created_at), resolved by the API. Posts often
// predate created_at, and every widget filters on post date, so starting at created_at would
// drop them. On any failure the old 180-day default stays.
useEffect(() => {
  if (!props.linkedCampaignId) return;
  let cancelled = false;
  setRangeReady(false);
  (async () => {
    try {
      const res: any = await analyticsService.brandPulseCampaignDateRange({
        campaign_id: props.linkedCampaignId,
        share_access_key: props?.share_access_key || undefined,
      });
      if (cancelled) return;
      const startAt = res?.status === gtUtil.Constants.SUCCESS ? res?.data?.campaign_start_at : null;
      const start = startAt ? new Date(startAt) : null;
      const now = new Date();
      if (start && !isNaN(start.getTime()) && start <= now) {
        // local midnight of the start day, so the first post is always inside the range
        const from = new Date(start.getFullYear(), start.getMonth(), start.getDate());
        setIsQuickRange(true); // apply num_of_days below as-is (same path as the quick buttons)
        setDateFrom(from);
        setDateTo(now);
        // +1 day of slack: the API filters on NOW() - num_of_days at request time, so this keeps
        // the first post in range despite request latency / clock skew
        setSelectedNumDays((calcNumDays(from) ?? 1) + 1);
      }
    } catch (err) {
      console.error("brandPulseCampaignDateRange Error:", err);
    } finally {
      if (!cancelled) setRangeReady(true);
    }
  })();
  return () => { cancelled = true; };
}, [props.linkedCampaignId]);

const brandPulseProcessingUrls = async (campaign_id: number, platform:string) => {
      try {
        if (campaign_id === 0) return;
        setLoadingInfluencerType(true);
        const response = await analyticsService.brandPulseProcessingUrls({ campaign_id: campaign_id, platform: platform, share_access_key: props?.share_access_key || undefined });
        setProcessingUrls(response?.data);
        // set API DATA
      } catch (err) {
        console.error("fetchINfluencerByType Error:", err);
      } finally {
        setLoadingInfluencerType(false);
      }
    }

useEffect(() => {
  if (!dateFrom || !dateTo) return;

  if (!isQuickRange) {
    const diffTime = dateTo.getTime() - dateFrom.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    setSelectedNumDays(diffDays < 1 ? 1 : diffDays);
  }
}, [dateFrom, dateTo]);
    const fetchMetricsFB = async () => {
      const reqId = ++metricsReqId.current;
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.fbAnalyticsMainDashboard({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        if (reqId !== metricsReqId.current) return; // a newer request superseded this one
        setDataMetrics(response?.data?.rows[0]);
      } catch (err) {
        console.error("Metrics Error:", err);
      } finally {
        if (reqId === metricsReqId.current) {
          setLoadingMetrics(false);
          setInitialMetricsLoading(false);
        }
      }
    };

    const fetchInfluencerByTypeFB = async () => {
      try {
        setLoadingInfluencerType(true);
        const response = await analyticsService.fbAnalyticsInfluencerByType({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        setInfluencerTypeData(response?.data);
        // set API DATA
      } catch (err) {
        console.error("fetchINfluencerByType Error:", err);
      } finally {
        setLoadingInfluencerType(false);
      }
    }

    const fetchLineChartsFB = async () => {
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.fbAnalyticsLineChart({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        setFbViedData(response?.data);   // set API DATA
      } catch (err) {
        console.error("fetchLineCharts Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

    const fbAnalyticsSentiment = async () => {
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.fbAnalyticsSentiment({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        setSentimentData(response?.data);   // set API DATA
      } catch (err) {
        console.error("fbAnalyticsSentiment Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

    const fbAnalyticsPostLevelPerformance = async () => {
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.fbAnalyticsPostLevelPerformance({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, page,
        limit, share_access_key: props?.share_access_key || undefined });
        setPosts(response?.data?.rows);   // set API DATA
        setTotalCount(response?.data?.totalCount || 0);
      } catch (err) {
        console.error("fbAnalyticsPostLevelPerformance Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

    const fbAnalyticsTopPerformingHashtag = async () => {
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.fbAnalyticsTopPerformingHashtag({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        setHashTagData(response?.data?.rows);   // set API DATA
      } catch (err) {
        console.error("fbAnalyticsTopPerformingHashtag Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

    const fbAnalyticsDemography = async () => {
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.fbAnalyticsDemography({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        setDemography(response?.data);   // set API DATA
      } catch (err) {
        console.error("fbAnalyticsDemography Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }
  useEffect(() => {
    // OLD: if (selectedPlatform !== "facebook") return;
    if (selectedPlatform !== "facebook" || !rangeReady) return;
    fetchMetricsFB();
    fetchInfluencerByTypeFB();
    fetchLineChartsFB();

    if (selectedPlatform === 'facebook') {
      fbAnalyticsSentiment();
    }
    fbAnalyticsDemography()
    fbAnalyticsPostLevelPerformance();
    fbAnalyticsTopPerformingHashtag();
    brandPulseProcessingUrls(props?.linkedCampaignId || 0, "facebook");
  }, [selectedPlatform, props.linkedCampaignId, rangeReady]);
  const fetchTopPerformers = async () => {
  if (!selectedPlatform) return;

  setLoadingTopPerformer(true);

  try {
    let response;

    if (selectedPlatform === "facebook") {
      response = await analyticsService.fbAnalyticsTopPerformer({
        campaign_id: props.linkedCampaignId,
        num_of_days: selectedNumDays,
        type: selectedTab,
        share_access_key: props?.share_access_key || undefined
      });
    }

    if (selectedPlatform === "instagram") {
      response = await analyticsService.igAnalyticsTopPerformance({
        campaign_id: props.linkedCampaignId,
        num_of_days: selectedNumDays,
        type: selectedTab,
        share_access_key: props?.share_access_key || undefined
      });
    }

    if (selectedPlatform === "youtube") {
      response = await analyticsService.ytAnalyticsTopPerformer({
        campaign_id: props.linkedCampaignId,
        num_of_days: selectedNumDays,
        type: selectedTab,
        share_access_key: props?.share_access_key || undefined
      });
    }

    setTopPerformerData(response?.data);
  } catch (err) {
    console.error("Top Performer Error:", err);
  } finally {
    setLoadingTopPerformer(false);
  }
};
  // const fbAnalyticsTopPerformer = async () => {
  //   try {
  //     setLoadingTopPerformer(true);
  //     const response = await analyticsService.fbAnalyticsTopPerformer({
  //       campaign_id: 827,
  //       num_of_days: selectedNumDays,
  //       type: selectedTab,
  //     });
  //     setTopPerformerData(response?.data?.rows);
  //   } catch (err) {
  //     console.error("fbAnalyticsTopPerformer Error:", err);
  //   } finally {
  //     setLoadingTopPerformer(false);
  //   }
  // }

  // const igAnalyticsTopPerformance = async () => {
  //     try {
  //       setLoadingTopPerformer(true);
  //       const response = await analyticsService.igAnalyticsTopPerformance({
  //         campaign_id: 826,
  //         num_of_days: selectedNumDays,
  //         type: selectedTab,
  //       });
  //       setTopPerformerData(response?.data?.rows);
  //     } catch (err) {
  //       console.error("igAnalyticsTopPerformance Error:", err);
  //     } finally {
  //       setLoadingTopPerformer(false);
  //     }
  //   };

  // const ytAnalyticsTopPerformer = async () => {
  //   try {
  //     setLoadingTopPerformer(true);
  //     const response = await analyticsService.ytAnalyticsTopPerformer({
  //       campaign_id: 999,
  //       num_of_days: selectedNumDays,
  //       type: selectedTab,
  //     });
  //     setTopPerformerData(response?.data?.rows);
  //   } catch (err) {
  //     console.error("ytAnalyticsTopPerformer Error:", err);
  //   } finally {
  //     setLoadingTopPerformer(false);
  //   }
  // };
  // useEffect(() => {
  //   if (!selectedPlatform) return;

  //   if (selectedPlatform === "facebook") {
  //     fbAnalyticsTopPerformer();
  //   } else if (selectedPlatform === "instagram") {
  //     igAnalyticsTopPerformance();
  //   } else if (selectedPlatform === "youtube") {
  //     ytAnalyticsTopPerformer();
  //   }

  // }, [selectedTab, selectedPlatform]);
  useEffect(() => {
    if (!rangeReady) return;
    fetchTopPerformers();
  }, [selectedPlatform, props.linkedCampaignId, rangeReady]);
    const fetchMetricsIG = async () => {
      const reqId = ++metricsReqId.current;
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.igAnalyticsMainDashboard({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        if (reqId !== metricsReqId.current) return; // a newer request superseded this one
        setDataMetrics(response?.data ?? {});   // set API DATA
      } catch (err) {
        console.error("Metrics Error:", err);
      } finally {
        if (reqId === metricsReqId.current) {
          setLoadingMetrics(false);
          setInitialMetricsLoading(false);
        }
      }
    };

    const fetchInfluencerType = async () => {
      try {
        setLoadingInfluencerType(true);
        const response = await analyticsService.igAnalyticsGetInfluencerType({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        setInfluencerTypeData(response?.data);   
      } catch (err) {
        console.error("Metrics Error:", err);
      } finally {
        setLoadingInfluencerType(false);
      }
    };

    const fetchGraphDataType = async () => {
      try {
        setLoadingContentType(true);
        const response = await analyticsService.igAnalyticsGetGraphData({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        setFbViedData(response?.data);
      } catch (err) {
        console.error("Metrics Error:", err);
      } finally {
        setLoadingContentType(false);
      }
    };
    const igAnalyticsPostLevelPerformance = async () => {
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.igAnalyticsPostLevelPerformance({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays,page,
        limit, share_access_key: props?.share_access_key || undefined });
        setPosts(response?.data?.rows);  // set API DATA
        setTotalCount(response?.data?.totalCount || 0);          
      } catch (err) {
        console.error("fbAnalyticsPostLevelPerformance Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

    const igAnalyticsTopPerformingHashtag = async () => {
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.igAnalyticsTopPerformingHashtag({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        setHashTagData(response?.data?.rows);   // set API DATA
      } catch (err) {
        console.error("igAnalyticsTopPerformingHashtag Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }


    const igAnalyticsSentiment = async () => {
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.igAnalyticsSentiment({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        setSentimentData(response?.data);   // set API DATA
      } catch (err) {
        console.error("fbAnalyticsSentiment Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

    const igAnalyticsDemography = async () => {
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.igAnalyticsDemography({ campaign_id: props.linkedCampaignId, num_of_days: selectedNumDays, share_access_key: props?.share_access_key || undefined });
        setDemography(response?.data);   // set API DATA
      } catch (err) {
        console.error("igAnalyticsDemography Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

    
useEffect(() => {
  // OLD: if (selectedPlatform !== "instagram") return;
  if (selectedPlatform !== "instagram" || !rangeReady) return;
 
    fetchMetricsIG();
    fetchInfluencerType();
    fetchGraphDataType();
    igAnalyticsPostLevelPerformance();
    igAnalyticsTopPerformingHashtag();
    igAnalyticsDemography();
    brandPulseProcessingUrls(props?.linkedCampaignId || 0, "instagram");
    if (selectedPlatform === 'instagram') {
      igAnalyticsSentiment()
    }
  }, [selectedPlatform, props.linkedCampaignId, rangeReady]);
  // const activeViewData = fbViewData?.view_chart;
  // const activeLikeData = fbViewData?.like_chart;
  // const activeCommentData = fbViewData?.comment_chart;
  // const activeERData = fbViewData?.er_chart;
 const fetchMetricsYT = async () => {
      const reqId = ++metricsReqId.current;
      try {
        setLoadingMetrics(true);
        const response = await analyticsService.ytAnalyticsMainDashboard({campaign_id: props.linkedCampaignId, num_of_days:selectedNumDays, share_access_key: props?.share_access_key || undefined});
        if (reqId !== metricsReqId.current) return; // a newer request superseded this one
        setDataMetrics(response?.data);   // set API DATA
      } catch (err) {
        console.error("Metrics Error:", err);
      } finally {
        if (reqId === metricsReqId.current) {
          setLoadingMetrics(false);
          setInitialMetricsLoading(false);
        }
      }
    };

    const fetchInfluencerByTypeYT = async () => {
      try {
        setLoadingInfluencerType(true);
        const response = await analyticsService.ytAnalyticsInfluencerByType({campaign_id: props.linkedCampaignId, num_of_days:selectedNumDays, share_access_key: props?.share_access_key || undefined});
        setInfluencerTypeData(response?.data); 
      } catch (err) {
        console.error("fetchINfluencerByType Error:", err);
      } finally {
        setLoadingInfluencerType(false);
      }
    }

    const fetchLineChartsYT = async () => {
    try {
        setLoadingMetrics(true);
        const response = await analyticsService.ytAnalyticsLineChart({campaign_id: props.linkedCampaignId, num_of_days:selectedNumDays, share_access_key: props?.share_access_key || undefined});
        setFbViedData(response?.data);   // set API DATA
      } catch (err) {
        console.error("fetchLineCharts Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

const ytAnalyticsSentiment = async () => {
    try {
        setLoadingMetrics(true);
        const response = await analyticsService.ytAnalyticsSentiment({campaign_id: props.linkedCampaignId, num_of_days:selectedNumDays, share_access_key: props?.share_access_key || undefined});
        setSentimentData(response?.data);   // set API DATA
      } catch (err) {
        console.error("ytAnalyticsSentiment Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

    const ytAnalyticsPostLevelPerformance = async () => {
    try {
        setLoadingMetrics(true);
        const response = await analyticsService.ytAnalyticsPostLevelPerformance({campaign_id: props.linkedCampaignId, num_of_days:selectedNumDays, page, limit, share_access_key: props?.share_access_key || undefined});
        setPosts(response?.data?.rows);   // set API DATA
        setTotalCount(response?.data?.totalCount || 0);
      } catch (err) {
        console.error("ytAnalyticsPostLevelPerformance Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }
    
    const ytAnalyticsTopPerformingHashtag = async () => {
    try {
        setLoadingMetrics(true);
        const response = await analyticsService.ytAnalyticsTopPerformingHashtag({campaign_id: props.linkedCampaignId, num_of_days:selectedNumDays, share_access_key: props?.share_access_key || undefined});
        setHashTagData(response?.data?.rows);   // set API DATA
      } catch (err) {
        console.error("ytAnalyticsTopPerformingHashtag Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

    const ytAnalyticsDemography = async () => {
    try {
        setLoadingMetrics(true);
        const response = await analyticsService.ytAnalyticsDemography({campaign_id: props.linkedCampaignId, num_of_days:selectedNumDays, share_access_key: props?.share_access_key || undefined});
        setDemography(response?.data);   // set API DATA
      } catch (err) {
        console.error("ytAnalyticsDemography Error:", err);
      } finally {
        setLoadingMetrics(false);
      }
    }

  useEffect(() => {
    // OLD: if (selectedPlatform !== "youtube") return;
    if (selectedPlatform !== "youtube" || !rangeReady) return;
    fetchMetricsYT();
    fetchInfluencerByTypeYT();
    fetchLineChartsYT();
    ytAnalyticsSentiment();
    ytAnalyticsPostLevelPerformance();
    ytAnalyticsTopPerformingHashtag();
    ytAnalyticsDemography();
    brandPulseProcessingUrls(props?.linkedCampaignId || 0, "youtube");
  }, [selectedPlatform, props.linkedCampaignId, rangeReady]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [postTableLoading, setPostTableLoading] = useState(false)
  const [limit, setLimit] = useState(10);
  const fetchMetricsAllPlatform = async () => {
      const reqId = ++metricsReqId.current;
      try {
        setLoadingMetrics(true);
        setPostTableLoading(true);
        const response = await analyticsService.allPlatformAnalyticsMainDashboard({campaign_id: props.linkedCampaignId, num_of_days:selectedNumDays, page,
        limit, share_access_key: props?.share_access_key || undefined});
        if (reqId !== metricsReqId.current) return; // a newer request superseded this one
        setDataMetrics(response?.data.metrics[0]);
        setFbViedData(response?.data?.chartData);
        setPosts(response?.data?.postLevelPerformance);
        setTotalCount(response?.data?.totalCount || 0);
        setHashTagData(response?.data?.topPerformingHashtag);
        setTopPerformerData(response?.data?.topPerforming);
        setDemography(response?.data?.demographyData);
        setInfluencerByType(response?.data?.influencerPlatform)
        setInfluencerTypeData(response?.data?.influencerPlatform)
        setSentimentData(response?.data?.sentimentData)
      } catch (err) {
        console.error("Metrics Error:", err);
      } finally {
        if (reqId === metricsReqId.current) {
          setLoadingMetrics(false);
          setPostTableLoading(false);
          setInitialMetricsLoading(false);
        }
      }
    };


  // useEffect(() => {
  //   fetchMetricsAllPlatform();
  // }, [page, selectedNumDays, limit, props.linkedCampaignId]);

useEffect(() => {
  // OLD: if (!props.linkedCampaignId || !selectedNumDays) return;
  if (!props.linkedCampaignId || !selectedNumDays || !rangeReady) return;

  if (selectedPlatform === "all") {
    fetchMetricsAllPlatform();
  } else if (selectedPlatform === "facebook") {
    fbAnalyticsPostLevelPerformance();
  } else if (selectedPlatform === "instagram") {
    igAnalyticsPostLevelPerformance();
  } else if (selectedPlatform === "youtube") {
    ytAnalyticsPostLevelPerformance();
  }
// OLD: }, [selectedPlatform, page, limit, selectedNumDays, props.linkedCampaignId]);
}, [selectedPlatform, page, limit, selectedNumDays, props.linkedCampaignId, rangeReady]);
  // useEffect(() => {
  //   setPage(1);
  // }, [selectedNumDays, props.linkedCampaignId]);

  useEffect(() => {
    setPage(1);
  }, [selectedPlatform, props.linkedCampaignId]);
  
  //   useEffect(() => {
  //   if (selectedPlatform !== "all") return; 
  //   fetchMetricsAllPlatform();
  //   // fetchInfluencerByTypeYT();
  //   // fetchLineChartsYT();
  //   // ytAnalyticsSentiment();
  //   // ytAnalyticsPostLevelPerformance();
  //   // ytAnalyticsTopPerformingHashtag();
  //   // ytAnalyticsDemography();
  //   // brandPulseProcessingUrls(props?.linkedCampaignId || 0, "youtube");
  // }, [selectedPlatform]);


  // useEffect(() => {
  //   if (selectedPlatform === "all") {
  //     fetchMetricsAllPlatform();
  //   }
  // }, [selectedPlatform]);

  // NOTE: Removed a duplicate effect that also called fetchMetricsAllPlatform for
  // the "all" tab. The effect above (deps: selectedPlatform, page, limit,
  // selectedNumDays, linkedCampaignId) already covers it; having both fired two
  // concurrent all-platform requests on mount which raced and caused the metric
  // cards to flash "--" between the skeleton and the real data.
  // Old code (kept for reference):
  // useEffect(() => {
  //   if (
  //     selectedPlatform !== "all" ||
  //     !props.linkedCampaignId ||
  //     !selectedNumDays
  //   ) {
  //     return;
  //   }
  //   fetchMetricsAllPlatform();
  // }, [selectedPlatform, props.linkedCampaignId, selectedNumDays]);

  const refreshAllPlatformData = async () => {
  await fetchTopPerformers();
  if (selectedPlatform === "facebook") {
    // 🎯 All Facebook APIs
    fetchMetricsFB();
    fetchInfluencerByTypeFB();
    fetchLineChartsFB();
    fbAnalyticsSentiment();
    fbAnalyticsPostLevelPerformance();
    fbAnalyticsTopPerformingHashtag();
  }

  if (selectedPlatform === "instagram") {
    // 🎯 All Instagram APIs
    fetchMetricsIG();
    fetchInfluencerType();
    fetchGraphDataType();
    igAnalyticsPostLevelPerformance();
    igAnalyticsTopPerformingHashtag();
    igAnalyticsSentiment();
  }

  if (selectedPlatform === "youtube") {
    // 🎯 All YouTube APIs
    fetchMetricsYT();
    fetchInfluencerByTypeYT();
    fetchLineChartsYT();
    ytAnalyticsSentiment();
    ytAnalyticsPostLevelPerformance();
    ytAnalyticsTopPerformingHashtag();
    ytAnalyticsDemography();
  }
};
useEffect(() => {
  // OLD: if (!selectedPlatform) return;
  if (!selectedPlatform || !rangeReady) return;
  refreshAllPlatformData();
}, [selectedNumDays, props.linkedCampaignId, rangeReady]);
const activeViewData = fbViewData?.view_chart;
const activeLikeData = fbViewData?.like_chart;
const activeCommentData = fbViewData?.comment_chart;
const activeERData = fbViewData?.er_chart;

// const diffData = (activeERData ?? [])?.map((row: any, idx: number, arr: any[]) => {
//   const curr = Number(row.value ?? 0);
//   if (idx === 0) {
//     return { ...row, diff: 0 }; // first point: 0 (or null if you prefer)
//   }
//   const prev = Number(arr[idx - 1].value ?? 0);
//   const diff = Number((curr - prev).toFixed(3)); // keep precision
//   return { ...row, diff };
// });

const diffData = Array.isArray(activeERData)
  ? activeERData.map((row: any, idx: number, arr: any[]) => {
      const curr = Number(row?.value ?? 0);

      if (idx === 0) {
        return { ...row, diff: 0 };
      }

      const prev = Number(arr[idx - 1]?.value ?? 0);
      const diff = Number((curr - prev).toFixed(3));

      return { ...row, diff };
    })
  : [];

const buildDiffSeries = (series: any[]) => {
  if (!Array.isArray(series)) return [];

  return series.map((row, idx) => {
    const curr = Number(row.value ?? 0);

    if (idx === 0) {
      return { ...row, diff: curr, _isFirst: true };
    }

    const prev = Number(series[idx - 1].value ?? 0);
    const diff = Number((curr - prev).toFixed(3));

    return { ...row, diff, _isFirst: false };
  });
};

const viewDiffData = buildDiffSeries(activeViewData ?? []);
const likeDiffData = buildDiffSeries(activeLikeData ?? []);
const commentDiffData = buildDiffSeries(activeCommentData ?? []);
// Master loading flag for the analytics sections below the metric cards. While
// the (single) dashboard request is in flight we show a skeleton layout instead
// of empty cards / "No data available" placeholders.
const analyticsLoading = loadingMetrics || initialMetricsLoading;

// ---------- PDF report ----------
// "Generate PDF" re-renders this page in PDF mode (fixed desktop width, no
// buttons/tabs/animations, hover-only values printed, every post listed, no
// cost data by default -- same content as the shared link; the brand page can
// opt in to "Include cost data") and captures it section by
// section into an A4 landscape PDF. See components/pdf/captureReportPdf.ts.
const PLATFORM_LABELS: Record<string, string> = {
  all: 'All Platforms',
  instagram: 'Instagram',
  facebook: 'Facebook',
  youtube: 'YouTube',
};
const [generatingPdf, setGeneratingPdf] = useState(false);
// null = normal page; otherwise the PDF version being generated
const [pdfVariant, setPdfVariant] = useState<PdfVariant | null>(null);
const pdfMode = pdfVariant !== null;
const [pdfMenuOpen, setPdfMenuOpen] = useState(false);
// Brand page only: the PDF hides cost data by default (same as the shared link); the brand can
// opt in to a version with Total Spent, per-post cost and CPV/CPL/CPC/CPE.
const [pdfIncludeCost, setPdfIncludeCost] = useState(false);
// Cost data is hidden on the shared link always, and in the PDF unless "include cost" was picked.
const isSharedLink = props.share_access_key != null;
const hideCost = isSharedLink || (pdfMode && !pdfIncludeCost);
const [pdfPosts, setPdfPosts] = useState<any[] | null>(null);
const reportRef = useRef<HTMLDivElement>(null);

// The table on the page is paginated -- the PDF lists every post
// OLD: any failed/empty response (or a totalCount of 0) fell back to the posts on screen, so the
// PDF silently listed only the first page (10 posts) of a 333-post campaign.
// const fetchAllPostsForPdf = async (): Promise<any[]> => {
//   const current = Array.isArray(posts) ? posts : [];
//   if (current.length >= (totalCount || 0)) return current;
//   ...
//   return (await analyticsService.allPlatformAnalyticsMainDashboard(params))?.data?.postLevelPerformance || current;
// };
const fetchAllPostsForPdf = async (): Promise<any[]> => {
  const current = Array.isArray(posts) ? posts : [];
  // every post is already on screen (small campaigns) -- nothing to fetch
  if (totalCount > 0 && current.length >= totalCount) return current;
  const params = {
    campaign_id: props.linkedCampaignId,
    num_of_days: selectedNumDays,
    page: 1,
    // generous cap so a stale/zero totalCount can't cut the list short
    limit: Math.max(totalCount, current.length, 5000),
    share_access_key: props?.share_access_key || undefined,
  };
  const load = async (): Promise<any[] | undefined> => {
    if (selectedPlatform === 'instagram') return (await analyticsService.igAnalyticsPostLevelPerformance(params))?.data?.rows;
    if (selectedPlatform === 'facebook') return (await analyticsService.fbAnalyticsPostLevelPerformance(params))?.data?.rows;
    if (selectedPlatform === 'youtube') return (await analyticsService.ytAnalyticsPostLevelPerformance(params))?.data?.rows;
    return (await analyticsService.allPlatformAnalyticsMainDashboard(params))?.data?.postLevelPerformance;
  };
  let rows = await load().catch(() => undefined);
  if (!Array.isArray(rows) || rows.length < current.length) rows = await load().catch(() => undefined); // one retry
  // never produce a PDF with only part of the posts -- handleGeneratePdf shows an error instead
  if (!Array.isArray(rows) || rows.length < current.length) throw new Error('Could not load all posts for the PDF');
  return rows;
};

// variant: 'desktop' = full dashboard layout on A4 landscape,
//          'mobile'  = the page's phone layout on narrow, phone-shaped pages
const handleGeneratePdf = async (variant: PdfVariant) => {
  if (generatingPdf) return;
  // never allow cost in a PDF generated from the shared link
  const withCost = pdfIncludeCost && !isSharedLink;
  setPdfMenuOpen(false);
  setGeneratingPdf(true);
  let restoreLayout = () => {};
  try {
    const allPosts = await fetchAllPostsForPdf();
    // pin the chosen layout regardless of the browser window width
    restoreLayout = pinPdfLayout(variant);
    setPdfPosts(allPosts);
    setPdfVariant(variant);
    // let the page re-render at report width (charts re-measure; animations are off)
    await new Promise((resolve) => setTimeout(resolve, 1500));
    if (!reportRef.current) throw new Error('report not mounted');
    const title = props.campaignTitle || 'Campaign';
    const fileSafe = title.replace(/[^\w\- ]+/g, '').trim().replace(/\s+/g, '-') || 'campaign';
    const { captureReportPdf } = await import('./components/pdf/captureReportPdf');
    await captureReportPdf(reportRef.current, {
      // OLD: fileName: `${fileSafe}-${selectedPlatform}-report${variant === 'mobile' ? '-mobile' : ''}.pdf`,
      fileName: `${fileSafe}-${selectedPlatform}-report${withCost ? '-with-cost' : ''}${variant === 'mobile' ? '-mobile' : ''}.pdf`,
      page: PDF_VARIANTS[variant].page,
      footerText: `${title} | ${PLATFORM_LABELS[selectedPlatform] || selectedPlatform} | ${format(dateFrom, 'MMM dd, yyyy')} - ${format(dateTo, 'MMM dd, yyyy')}`,
    });
  } catch (err) {
    console.error('Generate PDF error:', err);
    toast.error('Could not generate the PDF. Please try again.');
  } finally {
    restoreLayout();
    setPdfVariant(null);
    setPdfPosts(null);
    setGeneratingPdf(false);
  }
};

const [refreshing, setRefreshing] = useState(false);
// true when any campaign_analytics row of this campaign already has refresh_required = true
const [refreshRequested, setRefreshRequested] = useState(false);
// the Refresh button is only for users with the update_campaign role
const [canRefresh, setCanRefresh] = useState(false);
useEffect(() => {
  if (!props.UserReducer?.user_id || props.share_access_key != null) return;
  rolesService.checkAccess({ access_roles: ['update_campaign'], user_id: props.UserReducer.user_id })
    .then((res: any) => setCanRefresh(res?.data?.rows?.length > 0))
    .catch((err: any) => console.error('Refresh access check failed:', err));
}, [props.UserReducer?.user_id]);
useEffect(() => {
  if (!props.linkedCampaignId || props.share_access_key != null) return;
  let cancelled = false;
  setRefreshRequested(false);
  analyticsService.brandPulseRefreshStatus({ campaign_id: props.linkedCampaignId })
    .then((res: any) => { if (!cancelled) setRefreshRequested(!!res?.data?.refresh_requested); })
    .catch((err: any) => console.error('Refresh status error:', err));
  return () => { cancelled = true; };
}, [props.linkedCampaignId]);
// Flags campaign_analytics.refresh_required = true for this campaign (done server-side)
const handleRefresh = async () => {
  if (!canRefresh || refreshing || refreshRequested || !props.linkedCampaignId) return;
  setRefreshing(true);
  try {
    const res: any = await analyticsService.refreshBrandPulseCampaignAnalytics({ campaign_id: props.linkedCampaignId, user_id: props.UserReducer?.user_id });
    if (res?.status !== 1) throw new Error(res?.info);
    setRefreshRequested(true);
    toast.success('Refresh requested. Analytics will update shortly.');
  } catch (err) {
    console.error('Refresh error:', err);
    toast.error('Could not request a refresh. Please try again.');
  } finally {
    setRefreshing(false);
  }
};
  return (
    <PdfModeContext.Provider value={pdfVariant || false}>
      {generatingPdf && (
        <div className="fixed inset-0 flex items-center justify-center" style={{ zIndex: 2000, background: 'rgba(255,255,255,0.95)' }}>
          <div className="flex items-center gap-3 text-slate-700" style={{ fontSize: 16 }}>
            <Loader2 className="h-5 w-5 animate-spin" />
            Generating PDF…
          </div>
        </div>
      )}
      {/* <div className=" mx-auto"> */}
      <div
        className={`mx-auto${pdfMode ? ' pdf-capture' : ''}`}
        ref={reportRef}
        style={pdfVariant ? { width: PDF_VARIANTS[pdfVariant].width, maxWidth: 'none', background: '#ffffff', padding: '8px 4px' } : undefined}
      >
        {/* PDF header: same heading style as the shared link page */}
        {pdfMode && (
          <div data-pdf-block data-pdf-title="Overview" style={{ textAlign: 'center', padding: '12px 0 20px' }}>
            <div style={{ fontSize: 13, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#64748b' }}>Campaign Performance</div>
            <div style={{ marginTop: 8, fontSize: 32, fontWeight: 600, color: '#0f172a', lineHeight: 1.25 }}>
              {props.campaignTitle || 'Campaign'}
            </div>
            <div style={{ width: 56, height: 3, borderRadius: 2, background: '#0f172a', margin: '20px auto 12px' }} />
            <div style={{ fontSize: 14, color: '#475569' }}>
              {PLATFORM_LABELS[selectedPlatform] || selectedPlatform}
              <span style={{ margin: '0 10px', color: '#cbd5e1' }}>|</span>
              {format(dateFrom, 'MMM dd, yyyy')} – {format(dateTo, 'MMM dd, yyyy')}
            </div>
          </div>
        )}
        {/* Header */}

          {!pdfMode && (
          <div className="date-range-wrapper flex items-center gap-3 md:justify-end"
          style={{ marginTop: props.share_access_key ? "30px" : "0px" }}>
            {/* <select 
                className="px-4 py-2 border border-slate-300 rounded-lg bg-white"
                value={dateRange}
                onChange={(e) => setDateRange(e.target.value)}
              >
                <option>Till Date</option>
                <option>Last 7 days</option>
                <option>Last 30 days</option>
                <option>Last 6 months</option>
                <option>Last 1 year</option>
                <option>Custom</option>
              </select> */}

            {dateRange === 'Custom' && (
              <Popover >
                <PopoverTrigger asChild >
                  <Button variant="outline" className="gap-2">
                    <CalendarIcon className="h-4 w-4" />
                    Select Dates
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="end">
                  <div className="p-4 space-y-4">
                    <div>
                      <label className="text-sm text-slate-700 mb-2 block">Start Date</label>
                      <Calendar
                        mode="single"
                        selected={customStartDate}
                        onSelect={setCustomStartDate}
                        initialFocus
                      />
                    </div>
                    <div className="border-t pt-4">
                      <label className="text-sm text-slate-700 mb-2 block">End Date</label>
                      <Calendar
                        mode="single"
                        selected={customEndDate}
                        onSelect={setCustomEndDate}
                        disabled={(date: any) =>
                          customStartDate ? date < customStartDate : false
                        }
                      />
                    </div>
                  </div>
                </PopoverContent>
              </Popover>
            )}
            <Popover>
              <div id="date-range-container">
                <PopoverTrigger className='items-left flex' >
                  <Button variant="outline" className="w-30 align-left items-left">
                    {/* <Calendar className="w-4 h-4 mr-2" /> */}
                    <span>
                      {dateFrom && dateTo ? (
                        `${format(dateFrom, "MMM dd, yyyy")} - ${format(dateTo, "MMM dd, yyyy")}`
                      ) : (
                        "Select date range"
                      )}
                    </span>
                  </Button>
                </PopoverTrigger>
                <PopoverContent side="bottom"
                  align="end"
                  sideOffset={2} className="w-100 p-0" style={{ minWidth: '600px' }} >
                  <div className="p-3 space-y-2">
                    <div className="p-3 flex gap-2 flex-wrap">
                      <Button
                        variant="outline"
                        size="sm"
                        
                        onClick={()=>setLastDays(7)}
                      >
                        Last 7 days
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        
                        onClick={()=>setLastDays(30)}
                      >
                        Last 30 days
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        
                        onClick={()=>setLastDays(90)}
                      >
                        Last 90 days
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={()=>setLastDays(180)}
                      >
                        Last 180 days
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        
                        onClick={()=>setLastDays(365)}
                      >
                        Last 365 days
                      </Button>
                    </div>
                    <div className='d-flex'>
                      <div className='col-md-6'>
                        <label className="text-sm text-gray-600 mb-2 block">From</label>
                        <CalendarComponent
                          mode="single"
                          selected={dateFrom}
                          onSelect={handleFromDateSelect}
                          initialFocus
                        />
                      </div>
                      <div className='col-md-6'>
                        <label className="text-sm text-gray-600 mb-2 block">To</label>
                        <CalendarComponent
                          mode="single"
                          selected={dateTo}
                          onSelect={handleToDateSelect}
                          disabled={(date) => dateFrom ? date < dateFrom : false}
                        />
                      </div>
                    </div>
                  </div>

                </PopoverContent>
              </div>
            </Popover>
          </div>
          )}

        {/* Platform Tabs */}
        <Tabs value={selectedPlatform} onValueChange={setSelectedPlatform} className="w-full tab-all-platform">
          {!pdfMode && (
          <div className="flex items-start md:items-center md:justify-between flex-col md:flex-row mt-2">
            <TabsList  className="bg-[#f2f2f2] gap-2 tab-platform-change mb-2 md:mb-0">
              <TabsTrigger value="all">All Platforms</TabsTrigger>
              <TabsTrigger value="instagram">Instagram</TabsTrigger>
              <TabsTrigger value="facebook">Facebook</TabsTrigger>
              <TabsTrigger value="youtube">YouTube</TabsTrigger>
            </TabsList>
            <div className="flex items-center gap-2">
              <Popover open={pdfMenuOpen} onOpenChange={setPdfMenuOpen}>
                <PopoverTrigger asChild>
                  <button
                    disabled={generatingPdf || analyticsLoading}
                    className="btn btn-outline-primary btn-sm d-flex items-start"
                    title="Download this report as a PDF"
                  >
                    {generatingPdf ? (
                      <Loader2 className="h-4 w-4 mr-1 align-self-center animate-spin" />
                    ) : (
                      <FileDown className="h-4 w-4 mr-1 align-self-center" />
                    )}
                    {generatingPdf ? 'Generating…' : 'Generate PDF'}
                  </button>
                </PopoverTrigger>
                <PopoverContent align="end" className="w-64 p-1 bg-white">
                  {/* Brand page only - the shared link PDF never contains cost data */}
                  {!isSharedLink && (
                    <label className="flex items-start gap-2 rounded-md px-3 py-2 mb-1 border-b border-slate-100 cursor-pointer hover:bg-slate-50">
                      <input
                        type="checkbox"
                        className="mt-1"
                        checked={pdfIncludeCost}
                        onChange={(e) => setPdfIncludeCost(e.target.checked)}
                      />
                      <span>
                        <span className="block text-sm text-slate-900">Include cost data</span>
                        <span className="block text-xs text-slate-500">Total spent, post cost, CPV/CPL/CPC/CPE</span>
                      </span>
                    </label>
                  )}
                  <button
                    onClick={() => handleGeneratePdf('desktop')}
                    className="w-full text-left rounded-md px-3 py-2 hover:bg-slate-100"
                  >
                    <div className="text-sm text-slate-900">Desktop PDF</div>
                    <div className="text-xs text-slate-500">Full dashboard layout, A4 landscape</div>
                  </button>
                  <button
                    onClick={() => handleGeneratePdf('mobile')}
                    className="w-full text-left rounded-md px-3 py-2 hover:bg-slate-100"
                  >
                    <div className="text-sm text-slate-900">Mobile PDF</div>
                    <div className="text-xs text-slate-500">Phone layout, easy to read on a phone</div>
                  </button>
                </PopoverContent>
              </Popover>
            {props.share_access_key == null && canRefresh && (
              <button
                onClick={handleRefresh}
                disabled={refreshing || refreshRequested || !props.linkedCampaignId}
                className="btn btn-outline-primary btn-sm d-flex items-start"
                title="Mark this campaign's analytics for refresh"
              >
                {refreshing ? (
                  <Loader2 className="h-4 w-4 mr-1 align-self-center animate-spin" />
                ) : (
                  <RefreshCw className="h-4 w-4 mr-1 align-self-center" />
                )}
                {refreshRequested ? 'Refresh Requested' : 'Refresh'}
              </button>
            )}
            {props.share_access_key == null && (
              <button
                onClick={() => setIsAddPostDialogOpen(true)}
                className="btn btn-primary btn-sm d-flex items-start"
              >
                <Plus className="h-4 w-4 mr-1 align-self-center" />
                Add Post
              </button>
            )}
            </div>
            
          </div>
          )}

          <TabsContent value={selectedPlatform} className="space-y-6 mt-6">
            {/* Key Metrics Overview */}
            <div data-pdf-block data-pdf-title="Key Metrics">
            <MetricsOverview platform={selectedPlatform} dataMetrics={dataMetrics}
              loading={loadingMetrics || initialMetricsLoading} shared={hideCost} />
            </div>

            {analyticsLoading ? (
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <Skeleton variant="rectangular" height={300} sx={{ borderRadius: '8px' }} />
                  <Skeleton variant="rectangular" height={300} sx={{ borderRadius: '8px' }} />
                  <Skeleton variant="rectangular" height={300} sx={{ borderRadius: '8px' }} />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <Skeleton variant="rectangular" height={250} sx={{ borderRadius: '8px' }} />
                  <Skeleton variant="rectangular" height={250} sx={{ borderRadius: '8px' }} />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <Skeleton variant="rectangular" height={250} sx={{ borderRadius: '8px' }} />
                  <Skeleton variant="rectangular" height={250} sx={{ borderRadius: '8px' }} />
                </div>
                <Skeleton variant="rectangular" height={300} sx={{ borderRadius: '8px' }} />
                <Skeleton variant="rectangular" height={350} sx={{ borderRadius: '8px' }} />
              </div>
            ) : (
              <>
            {/* Conditional Layout based on platform */}
            {selectedPlatform === 'all' ? (
              <>
                {/* All Platforms: Original Layout */}
                <div data-pdf-block data-pdf-title="Influencers">
                <InfluencerPieCharts platform={selectedPlatform} posts={posts} data={influencerTypeData}  loading={loadingInfluencerType} shared={hideCost} />
                </div>
              </>
            ) : (
              <>
                {/* Individual Platforms: Combined 3-column layout */}
                <div data-pdf-block data-pdf-title="Influencers" className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  {/* Influencers by Type (from InfluencerPieCharts) */}
                  <InfluencerPieCharts platform={selectedPlatform} posts={posts} data={influencerTypeData} loading={loadingInfluencerType} shared={hideCost} />

                  {/* Post Type Insights */}
                  <PostTypeInsights platform={selectedPlatform} datametrics={influencerTypeData} loading={loadingInfluencerType} />
                </div>
              </>
            )}
            {/* Metrics Cards */}
            {/* Charts Grid - 4 Separate Charts */}
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <Card data-pdf-block data-pdf-title="Performance Over Time">
                <CardHeader>
                  <CardTitle className='mb-0'>Views</CardTitle>
                  <CardDescription>Track views over time</CardDescription>
                </CardHeader>
                <CardContent>
                  {activeViewData?.length === 0 && (<NoData message='No data available for Views.' />
                  )}
                  <ResponsiveContainer width="100%" height={pdfMode ? 160 : 200}>
                    <LineChart data={activeViewData} margin={pdfMode ? { top: 22, right: 24, left: 4, bottom: 0 } : undefined}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                      <XAxis
                        dataKey="date"
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                      />
                      <YAxis
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                      />
                      <Tooltip content={<RechartsNumberTooltip unit="Views" />} />

                      {/* MAIN LINE */}
                      <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#3b82f6"
                        strokeWidth={2}
                        dot={pdfMode}
                        isAnimationActive={!pdfMode}
                        label={pdfMode && (activeViewData?.length ?? 0) <= 20 ? { position: 'top', fontSize: 11, fill: '#334155', formatter: (v: any) => Number(v).toLocaleString('en-IN') } : false}
                        activeDot={{ r: 6 }}
                        name="Actual"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                  {pdfMode && (activeViewData?.length ?? 0) > 20 && <PdfSeriesGrid data={activeViewData} />}
                </CardContent>
              </Card>

              <Card data-pdf-block>
                <CardHeader>
                  <CardTitle className='mb-0'>Likes</CardTitle>
                  <CardDescription>Likes over time</CardDescription>
                </CardHeader>
                <CardContent>
                     {activeLikeData?.length === 0 && (<NoData message='No data available for Likes.' />
                  )}
                  <ResponsiveContainer width="100%" height={pdfMode ? 160 : 200}>
                    <LineChart data={activeLikeData} margin={pdfMode ? { top: 22, right: 24, left: 4, bottom: 0 } : undefined}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                      <XAxis
                        dataKey="date"
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                      />
                      <YAxis
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                      />
                      <Tooltip content={<RechartsNumberTooltip unit="Likes" />} />

                      {/* MAIN LINE */}
                      <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#ec4899"
                        strokeWidth={2}
                        dot={pdfMode}
                        isAnimationActive={!pdfMode}
                        label={pdfMode && (activeLikeData?.length ?? 0) <= 20 ? { position: 'top', fontSize: 11, fill: '#334155', formatter: (v: any) => Number(v).toLocaleString('en-IN') } : false}
                        activeDot={{ r: 6 }}
                        name="Actual"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                  {pdfMode && (activeLikeData?.length ?? 0) > 20 && <PdfSeriesGrid data={activeLikeData} />}
                </CardContent>
              </Card>

              <Card data-pdf-block>
                <CardHeader>
                  <CardTitle className='mb-0'>Comments</CardTitle>
                  <CardDescription>Comments over time</CardDescription>
                </CardHeader>
                <CardContent>
                  {activeCommentData?.length === 0 && (<NoData message='No data available for Comments.' />
                  )}
                  <ResponsiveContainer width="100%" height={pdfMode ? 160 : 200}>
                    <LineChart data={activeCommentData} margin={pdfMode ? { top: 22, right: 24, left: 4, bottom: 0 } : undefined}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                      <XAxis
                        dataKey="date"
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                      />
                      <YAxis
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                      />
                      <Tooltip content={<RechartsNumberTooltip unit="Comments" />} />

                      {/* MAIN LINE */}
                      <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#8b5cf6"
                        strokeWidth={2}
                        dot={pdfMode}
                        isAnimationActive={!pdfMode}
                        label={pdfMode && (activeCommentData?.length ?? 0) <= 20 ? { position: 'top', fontSize: 11, fill: '#334155', formatter: (v: any) => Number(v).toLocaleString('en-IN') } : false}
                        activeDot={{ r: 6 }}
                        name="Actual"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                  {pdfMode && (activeCommentData?.length ?? 0) > 20 && <PdfSeriesGrid data={activeCommentData} />}
                  {/* <ResponsiveContainer width="100%" height={200}>
                    <LineChart data={activeCommentData ?? []}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                      <XAxis
                        dataKey="date"
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                      />
                      <YAxis
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                      />
                      <Tooltip content={<RechartsNumberTooltip unit="Comments" />} />
                      <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#8b5cf6"
                        strokeWidth={2}
                        dot={pdfMode}
                        isAnimationActive={!pdfMode}
                        label={pdfMode && (activeCommentData?.length ?? 0) <= 20 ? { position: 'top', fontSize: 11, fill: '#334155', formatter: (v: any) => Number(v).toLocaleString('en-IN') } : false}
                        activeDot={{ r: 6 }}
                      />
                    </LineChart>
                  </ResponsiveContainer> */}
                </CardContent>
              </Card>

              <Card data-pdf-block>
                <CardHeader>
                  <CardTitle className='mb-0'>Engagement Rate (ER)</CardTitle>
                  <CardDescription>Monthly trends over time</CardDescription>
                </CardHeader>
                <CardContent>
                  {activeERData?.length === 0 && (<NoData message='No data available for ER.' />
                  )}
                  <ResponsiveContainer width="100%" height={pdfMode ? 160 : 200}>
                    <LineChart data={activeERData ?? []} margin={pdfMode ? { top: 22, right: 24, left: 4, bottom: 0 } : undefined}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                      <XAxis
                        dataKey="date"
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                      />
                      <YAxis
                        tick={{ fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                      />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: 'white',
                          border: '1px solid #e5e7eb',
                          borderRadius: '8px',
                          padding: '8px 12px'
                        }}
                        formatter={(value) => [`${value}%`, 'ER']}
                      />
                      <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#10b981"
                        strokeWidth={2}
                        dot={pdfMode}
                        isAnimationActive={!pdfMode}
                        label={pdfMode && (activeERData?.length ?? 0) <= 20 ? { position: 'top', fontSize: 11, fill: '#334155', formatter: (v: any) => `${v}%` } : false}
                        activeDot={{ r: 6 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                  {pdfMode && (activeERData?.length ?? 0) > 20 && <PdfSeriesGrid data={activeERData} format={(val) => (val == null ? '-' : `${val}%`)} />}
                  
                </CardContent>
              </Card>
            </div>

            {/* Growth Charts - Views, Engagement, and Posts */}
            {/* <GrowthCharts platform={selectedPlatform} /> */}

            {/* Engagement Charts */}
            {/* <EngagementCharts platform={selectedPlatform} /> */}

            {/* Facebook Tab: 3-column layout with Sentiment, Reactions, and Hashtags */}
            {selectedPlatform === 'facebook' ? (
              <>
                <div data-pdf-block data-pdf-title="Sentiment & Hashtags" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <SentimentAnalysis loading={loadingMetrics} platform={selectedPlatform} sentimentData={sentimentData} />
                  <FacebookReactions platform={selectedPlatform} dataMetrics={dataMetrics} />
                  <HashtagCloud platform={selectedPlatform} hashTagData={hashTagData} />
                </div>
              </>
            ) : (
              /* Other Platforms: Sentiment Analysis and Top Hashtags - Side by Side */
              <div data-pdf-block data-pdf-title="Sentiment & Hashtags" className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <SentimentAnalysis loading={loadingMetrics} platform={selectedPlatform} sentimentData={sentimentData} />
                <HashtagCloud platform={selectedPlatform} hashTagData={hashTagData} />
                
              </div>
            )}

            {/* Top Performers */}
            <div data-pdf-block data-pdf-title="Top Performers">
            <TopPerformers platform={selectedPlatform} onTabChange={(value) => { setSelectedTab(value); setTopPerformerData([]) }} topPerformerData={topPerformerData} loading={loadingTopPerformer} />
            </div>

            {/* Demographics */}
            
            {/* <Demographics platform={selectedPlatform} demography={demography}/> */}
            

            {/* Posts Table */}
            {/* desktop PDF: the table gets a box on every page; mobile is a list of bordered cards */}
            <div data-pdf-block data-pdf-frame={pdfVariant === 'mobile' ? undefined : ''} data-pdf-title="Post-Level Performance">
            <PostsTable
              platform={selectedPlatform}
              isAddPostDialogOpen={isAddPostDialogOpen}
              onAddPostDialogChange={setIsAddPostDialogOpen}
              posts={pdfMode && pdfPosts ? pdfPosts : posts}
              onPostsChange={setPosts}
              onDeleteSuccess={refreshAllPlatformData} 
              linkedCampaignId={props?.linkedCampaignId || 0}
              page={page}
              setPage={setPage}
              limit={pdfMode && pdfPosts ? Math.max(pdfPosts.length, 1) : limit}
              loading={postTableLoading}
              totalCount={totalCount}
              setLimit={setLimit}
              // OLD: shared={props.share_access_key != null}
              shared={hideCost}
              hasFacebookPosts={(influencerTypeData?.influencer_by_platform || []).some(
                (row: any) => row?.platform?.toLowerCase() === 'facebook' && Number(row?.influencer_count) > 0
              )}
              hasInstagramPosts={(influencerTypeData?.influencer_by_platform || []).some(
                (row: any) => row?.platform?.toLowerCase() === 'instagram' && Number(row?.influencer_count) > 0
              )}
            />
            </div>
              </>
            )}
          </TabsContent>
        </Tabs>
      </div>
      <Toaster />
    </PdfModeContext.Provider>
  );
}

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
    UserID: state.UserID.userID,
    selectCampaign: state.InfSelectCamp.campaign,
    getSubscriptionDetail: state.Subscription.subscription_detail,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailedAnalyticsBrandPulseNew);

export { connectToRedux as DetailedAnalyticsBrandPulseNew };  
